<template>
  <div class="service-details">
    <div class="service-details-top">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="service-details-top-content">
            <h2>{{content[num].title1}}</h2>
<!--            <p>{{content[num].wordP1}}</p>
            <p>{{content[num].wordP2}}</p> -->
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="service-details-cent">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="service-details-cent-content">
            <h2>服务优势或特点说明</h2>
            <p>{{content[num].wordP3}}</p>
            <p>{{content[num].wordP4}}</p>
            <div class="service-details-cent">
              <div class="service-img">
				  <img :src="content[num].img" width="100%" height="100%">
              </div>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        num:this.$route.query.num,
        content:{
          "0":{
            title1:"综合运维保障服务",
            wordP1:'',
            wordP2:"",
            wordP3:"依托我司“综合运维管理系统”产品，结合专业的运维服务团队，向客户提供专业的综合运维服务，助理客户，透明化运维管理，",
            wordP4:"规范运维流程，量化运维工作，提高运维效率，降低运维成本。",
          },
          "1":{
            title1:"弱电智能化设计服务",
            wordP1:'',
            wordP2:"",
            wordP3:"以众多智能化设计案例为基础，依托专业的设计团队，遵循国家智能建筑设计（GB50314-2015）标准，",
            wordP4:"向客户提供专业的弱电智能化设计服务。",
          },
          "2":{
            title1:"系统集成服务",
            wordP1:'',
            wordP2:"",
            wordP3:"以大量系统集成服务案例为基础，依托专业的技术和实施团队，向客户提供专业的IT、信息安全、数据中心和云平台等系统集成服务。",
            wordP4:"",
          },
          "3":{
            title1:"智慧园区建设咨询服务",
            wordP1:'',
            wordP2:"",
            wordP3:"以众多智慧园区建设案例为基础，依托优秀的软件、网络、安全、物联网等领域专业技术团队，向客户提供专业的智慧园区建设咨询服务，",
            wordP4:"助力客户实现园区智慧化管理和发展。",
          },
          "4":{
            title1:"物联网建设咨询服务",
            wordP1:'',
            wordP2:"",
            wordP3:"基于我司“物联网网关”和“物联网综合管理平台”产品，依托专业的网络、智能化和软件团队，",
            wordP4:"向客户提供专业的物联网建设和基于物联网的智能系统建设咨询服务。",
          },
		  "5":{
		  title1:"锐捷网络产品服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"湖北锐捷最大的服务商，区域地盘包括武汉，黄冈，咸宁，黄石，宜昌，恩施，鄂州等地。",
		  wordP4:"2020全年销售锐捷网络产品4000万，为锐捷优选服务商。",
		  },
		  "6":{
		  title1:"等级保护建设服务咨询服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"依据等级保护标准对客户信息系统进行等保建设咨询，风险评估、差距分析、规划建设等。",
		  wordP4:"",
		  img:require("../../assets/img/djbg.png"),
		  },
		  "7":{
		  title1:"网络安全驻场运维服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"网络安全驻场运维服务包括：安全设备维护、策略调整、日常巡检、安全事件处理及响应、知识库的建立与更新等。加强网络管理人员的网络安全意识，提高网络信息系统的整体服务水平，并建立故障处理流程，规范故障处理工作，保证用户现有的信息系统的安全的运行。同时根据日常安全维护的数据和记录，提供用户信息系统的整体",
		  wordP4:"安全建设规划和建议，更好的为用户的信息化系统提供安全有力的保障；",
		  img:require("../../assets/img/wlaqzcfw.jpg"),
		  },
		  "8":{
		  title1:"安全巡检服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"信息安全是动态的，随着时间的变化会不断暴露出新的安全漏洞、恶意软件、攻击手段，新些将打打破现有信息安全的平衡。安全巡检服务是指定期对用户的网络系统、",
		  wordP4:"主机系统、业务系统等信息系统进行进行的安全检测，检测完成后提供全面的巡检服务报告，对用户存在的安全风险提供对应的修复建议；",
		  img:require("../../assets/img/aqxj.jpg"),
		  },
		  "9":{
		  title1:"安全加固服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"安全加固服务，是指根据安全加固列表，为了有效保障客户网络的安全运行，需要对操作系统、数据库、中间件、网络设备、安全设备进行安全检测后发现的安全风险进行修复。",
		  wordP4:"对目标系统的安全漏洞对进行修复、配置隐患进行优化。加固内容包括：操作系统、数据库、中间件、网络设备、安全设备等；",
		  img:require("../../assets/img/aqjg.jpg"),
		  },
		  "10":{
		  title1:"护网技术支持与重保值守服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"在国家重大活动（如国庆、两会等）期间，组织面临的安全攻击呈现攻击力度更大、攻击频率更高、针对性更强等特点。为落实相应的网络安全责任，保证关键信息基础设施及重要信息系统在重大活动期间的稳定运行，用户需要建立防护、监测、响应的安全机制，确保及时处置网络安全隐患，充分做好网络应急响应准备和安全保障工作，尽可能避免出现黑客攻击入侵、篡改事件、感染受勒索病毒等安全风险。通过重保类服务方案可以帮助用户在国家重大活动期间及时发现并处置网络安全隐患，充分做好网络应急响应准备和安全保障工作，避免出现黑客攻击入侵、篡改事件、感染勒索病毒等安全事件；",
		  wordP4:"",
		  img:require("../../assets/img/hwzc.jpg"),
		  },
		  "11":{
		  title1:"渗透测试服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"由渗透测试工程师模拟黑客对客户的目标应用系统及其宿主服务器进行非破坏性攻击的安全测试、深度漏洞挖掘，发现应用系统隐藏的安全隐患和安全风险，帮助客户提高应用程序的安全性。渗透测试的内容包含外部渗透和基于业务流程的深入渗透测试，包括：Web应用系统的渗透测试主要是对操作系统及服务漏洞、应用系统漏洞、安全配置缺陷、功能逻辑缺陷等方面进行全面测试，APP应用系统还需要对APP客户端漏洞进行针对性测试。具体测试方法可以考虑从以下方面进行：身份验证突破、策略配置漏洞、Web服务漏洞利用、访问控制突破、系统用户提权、内外网混联检测、网页代码漏洞、溢出漏洞攻击等；",
		  wordP4:"",
		  img:require("../../assets/img/stcs.jpg"),
		  },
		  "12":{
		  title1:"应急响应服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"在客户发生信息破坏事件（篡改、泄露、盗窃、丢失等）、大规模病毒事件、Web网站漏洞事件等相关的信息安全事件时，技术专家7*24小时值守，第一时间进行响应，及时采取措施，",
		  wordP4:"控制安全事件造成的影响范围，缩小损失，排查问题来源，提供基于安全事件的解决方案及后续处置；",
		  img:require("../../assets/img/yjxy.jpg"),
		  },
		  "13":{
		  title1:"网络安全培训服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"为客户提供网络安全等级保护制度合规咨询一站式服务，同时助力客户网络安全向“实战化、体系化、常态化”提升。 《网络安全法》明确要求国家实施网络安全等级保护制度，标志等级保护制度已成为国家网络安全的基本制度。",
		  wordP4:"等级保护合规咨询服务是围绕等级保护制度中定级备案、建设整改、定级测评、监督检查等“规定动作”提供的配套服务，在协助客户落实等级保护制度的同时，助力网络安全保障能力提升。",
		  img:require("../../assets/img/wlaqpx.jpg"),
		  },
		  "14":{
		  title1:"等保合规咨询服务",
		  wordP1:'',
		  wordP2:"",
		  wordP3:"针对客户的技术人员、管理人员和其他参与培训的人员提供网络安全培训，包括网络安全意识培训，网络安全技术培训，网络安全等级保护培训、网络安全法培训、云安全技术",
		  wordP4:"与管理培训和国内外网络安全形势培训等，树立用户的信息安全文化，提高全员的信息安全意识；",
		  img:require("../../assets/img/hgzx.jpg"),
		  }
        }
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .service-details{
    .service-details-top{
      background-size: 100% 100%;
      background-image: url(../../assets/img/banner1.png);
      background-repeat: no-repeat;
      padding-top: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .service-details-top-content{
        text-align: center;
        color: #ffffff;
        padding-bottom: 1rem;
        h2{
           font-family: SourceHanSansCN-Medium;
           font-size: 30px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 0px;
           letter-spacing: 0px;
           color: #ffffff;
          margin-top: 1rem;
          margin-bottom: 0.2rem;
        }
        // p{
        //    font-family: SourceHanSansCN-Regular;
        //    font-size: 24px;
        //    font-weight: normal;
        //    font-stretch: normal;
        //    // line-height: 0px;
        //    letter-spacing: 0px;
        //    color: #333333;
        // }
      }
    }
    .service-details-cent{
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      text-align: center;
      padding-top: 0.5rem;
      background-color: #f4f5fa;
      .service-details-cent-content{
        h2{
          margin-bottom: 0.2rem;
          font-family: SourceHanSansCN-Regular;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          // line-height: 0px;
          letter-spacing: 0px;
          color: #333333;
        }
        p{
           font-family: SourceHanSansCN-Light;
           font-size: 11px;
           font-weight: normal;
           font-stretch: normal;
           // line-height: 55px;
           letter-spacing: 0px;
           color: #253554;
        }
      }
      .service-details-cent{
        height: 4rem;
        .service-img{
          width: 360px;
          height: 230px;
          background-color: #ffffff;
          margin: 0 auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cor-service-content/ServiceDetails.vue